import React, { useState, useEffect } from 'react';
import instance from '../../services/endpoint';
import { Pagination } from 'react-bootstrap';
import { TbFileDownload } from 'react-icons/tb';
import { toast } from 'react-toastify';
import CustomDropdown from '../utilComponents/customDropDown.js';
import Loader from '../utilComponents/loader';

const SellTransactions = ({ searchQuery }) => {
  const [allTransactions, setAllTransactions] = useState([]);
  const [loadingButtons, setLoadingButtons] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    const fetchAllTransactions = async () => {
      setLoading(true);
      try {
        const response = await instance.get('api/v1/currexTxnHistory/getAllTransactions');
        const sellTransactions = response.data.transactions.filter(
          (t) => t.transactionType === "sell"
        );
        setAllTransactions(sellTransactions);
      } catch (err) {
        setError('Error fetching sell transactions');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchAllTransactions();
  }, []);

  const getTransactionKey = (t) => {
    return t.coinPaytransactionID || `${t.AccountID}-${t.currextransactionID || 'fallback'}`;
  };

  const handleAdminAction = async (coinPaytransactionID, updatedStatus, fallbackKey) => {
    const key = coinPaytransactionID || fallbackKey;

    if (!updatedStatus) {
      toast.info('Please select a status');
      return;
    }

    setLoadingButtons((prev) => ({ ...prev, [key]: true }));

    try {
      const response = await instance.post('/api/v1/razorpaytransaction/send-money', {
        coinPaytransactionID,
        adminAction: updatedStatus,
      });

      if (response.data.success) {
        toast.success('Transaction status updated successfully');
        setAllTransactions((prev) =>
          prev.map((t) =>
            getTransactionKey(t) === key
              ? { ...t, adminAction: updatedStatus }
              : t
          )
        );
      } else {
        toast.error(response.data.details || 'Failed to update');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error updating status');
      console.error(err);
    } finally {
      setLoadingButtons((prev) => ({ ...prev, [key]: false }));
    }
  };

  const handleStatusChange = (coinPaytransactionID, value, fallbackKey) => {
    const key = coinPaytransactionID || fallbackKey;
    setAllTransactions((prev) =>
      prev.map((t) =>
        getTransactionKey(t) === key
          ? { ...t, adminAction: value }
          : t
      )
    );
  };

  const filteredRequests = allTransactions.filter((t) => {
    const query = searchQuery.toLowerCase();
    return (
      t.AccountID?.toLowerCase().includes(query) ||
      t.coinPaytransactionID?.toLowerCase().includes(query) ||
      t.UPIaddress?.toLowerCase().includes(query) ||
      t.exchangeStatus?.toLowerCase().includes(query) ||
      t.senderStatus?.toLowerCase().includes(query) ||
      t.receiverStatus?.toLowerCase().includes(query)
    );
  });

  const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredRequests.slice(startIndex, startIndex + itemsPerPage);
  const pending = allTransactions.filter((t) => t.exchangeStatus === 'PENDING').length;

    //function to download CSV
    const downloadCSV = () => {
      const headers = ['AccountID', 'transactionType', 'currextransactionID','razorPayTransactionID','coinPaytransactionID', 'walletAddress', 'BaseCurrency', 'BaseAmount', 'ToCurrency', 'ToAmount', 'exchangeStatus', 'senderStatus', 'receiverStatus', 'isVerifiedWallet', 'adminAction', 'createdAt'];
      const rows = filteredRequests.map(req => [
        req.AccountID,
        req.transactionType,
        req.currextransactionID || "N/A",
        req.razorPayTransactionID || "N/A",
        req.coinPaytransactionID || "N/A",
        req.walletAddress || "N/A",
        req.BaseCurrency || "N/A",
        req.BaseAmount || "N/A",
        req.ToCurrency || "N/A",
        req.ToAmount || "N/A",
        req.exchangeStatus || "N/A",
        req.senderStatus || "N/A",
        req.receiverStatus || "N/A",
        req.isVerifiedWallet ? "Yes" : "No",
        req.adminAction || "N/A",
        req.createdAt
          ? (() => {
          const date = new Date(req.createdAt);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        })()
          : "N/A",
      ]);
    
      const csvContent =
        [headers, ...rows]
          .map(e => e.join(','))
          .join('\n');
    
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
    
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'deposit_requests.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

  return (
    <>
      {loading && <Loader />}
      <div>
        <h2>Sell Transactions</h2>
       <div className='csv' >
          {pending === 0 ? (
            <p style={{ color: "green" }}>No Pending Requests</p>
          ) : (
            <p style={{ color: "red" }}>Total Pending Requests: {pending}</p>
          )}
           <button onClick={downloadCSV} className="downloadBtn" style={{ alignSelf: "flex-end" }}><TbFileDownload /></button>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}

        <div className="scrollable-table">
          <table>
            <thead>
              <tr style={{ fontSize: "15px" }}>
                <th>Account ID</th>
                <th>Transaction Type</th>
                <th>CurrexTransactionID</th>
                <th>RazorPay-TransactionID</th>
                <th>CoinPay-TransactionID</th>
                <th>UPI Address</th>
                <th>Bank Account</th>
                <th>Base Currency</th>
                <th>Base Amount</th>
                <th>To Currency</th>
                <th>To Amount</th>
                <th>Exchange Status</th>
                <th>Sender Status</th>
                <th>Receiver Status</th>
                <th>Is Verified Wallet</th>
                <th>Admin Action</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((t) => {
                const key = getTransactionKey(t);

                return (
                  <tr key={key} style={{ fontSize: "12px" }}>
                    <td>{t.AccountID}</td>
                    <td>{t.transactionType}</td>
                    <td>{t.currextransactionID || "waiting"}</td>
                    <td>{t.razorPayTransactionID || "waiting"}</td>
                    <td>{t.coinPaytransactionID || "waiting..."}</td>
                    <td>{t.UPIaddress || "---"}</td>
                    <td style={{ textAlign: "left" }}>
                      Name: {t.bankName || "---"}<br />
                      AccNo: {t.bankAccNo || "---"}<br />
                      IFSC: {t.bankIFSC || "---"}
                    </td>
                    <td>{t.BaseCurrency}</td>
                    <td>{t.BaseAmount}</td>
                    <td>{t.ToCurrency}</td>
                    <td>{t.ToAmount}</td>
                    <td>{t.exchangeStatus}</td>
                    <td>{t.senderStatus}</td>
                    <td>{t.receiverStatus}</td>
                    <td>{t.isVerifiedWallet ? "✅" : "❌"}</td>
                    <td>{t.adminAction || "None"}</td>
                    <td>
                      <div style={{ fontSize: "12px", width: "auto" }}>
                        <CustomDropdown
                          options={["Approved", "Declined"]}
                          selected={t.adminAction}
                          onSelect={(value) =>
                            handleStatusChange(t.coinPaytransactionID, value, key)
                          }
                        />
                      </div>
                      <button
                        onClick={() =>
                          handleAdminAction(t.coinPaytransactionID, t.adminAction, key)
                        }
                        disabled={loadingButtons[key]}
                      >
                        {loadingButtons[key] ? "Updating..." : "Update Status"}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-center mt-3">
          <Pagination>
            {[...Array(totalPages)].map((_, pageIndex) => (
              <Pagination.Item
                key={pageIndex}
                active={currentPage === pageIndex + 1}
                onClick={() => setCurrentPage(pageIndex + 1)}
              >
                {pageIndex + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      </div>
    </>
  );
};

export default SellTransactions;
